import React, { useEffect, useState } from "react";
import axios, { cookies } from "../../axios/axios";
import { Link } from "react-router-dom";
import { FaRegEdit } from "react-icons/fa";
import EditorLayout from "./EditorLayout";

const CullingEditor = () => {
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState("");
  const [statusFilter, setStatusFilter] = useState(0); // 0 means no filter
  const user = cookies.get("user");
  const userName = user?.user?.fname;
  const userRole = user?.user?.role;

  useEffect(() => {
    if (userRole !== "editor") return;
    const fetchOrders = async () => {
      try {
        const response = await axios.get("/culling");
        const assignedOrders = response.data.filter(
          (order) => order.editor === userName
        );
        setOrders(assignedOrders);
      } catch (err) {
        setError("Failed to fetch orders");
      }
    };
    fetchOrders();
  }, [userName, userRole]);

  const getStatusDetails = (status) => {
    switch (status) {
      case 1:
        return { text: "New Order", className: " bg-primary text-light" };
      case 2:
        return { text: "In Progress", className: "bg-warning text-light" };
      case 3:
        return { text: "On Hold", className: "bg-secondary text-light" };
      case 4:
        return { text: "In QC", className: "bg-info text-dark" };
      case 5:
        return { text: "Sample Sent", className: "bg-success text-light" };
      case 6:
        return { text: "In Revision", className: "bg-info text-light" };
      case 7:
        return { text: "Cancelled", className: "bg-danger text-light" };
      case 8:
        return { text: "Completed", className: "bg-success text-light" };
      default:
        return { text: "Unknown", className: "bg-dark text-light" };
    }
  };

  const filteredOrders = orders.filter((val) => {
    if (statusFilter === 0) return true; // No filter applied
    return val.status === statusFilter;
  });

  if (userRole !== "editor") {
    return <div className="container mt-4">Access denied.</div>;
  }

  return (
    <EditorLayout>
      <div className="container mt-4">
        <h2>My Assigned Culling Orders</h2>
        {error && <div className="alert alert-danger">{error}</div>}
        <div className="my-4 col-md-3 mx-auto">
          <label htmlFor="statusFilter" className="form-label fw-bold">
            Filter by Status:
          </label>
          <select
            id="statusFilter"
            className="form-select"
            value={statusFilter}
            onChange={(e) => setStatusFilter(Number(e.target.value))}
          >
            <option value={0}>All</option>
            <option value={1}>New Order</option>
            <option value={2}>In Progress</option>
            <option value={3}>On Hold</option>
            <option value={4}>In QC</option>
            <option value={5}>Sample Sent</option>
            <option value={6}>In Revision</option>
            <option value={7}>Cancelled</option>
            <option value={8}>Completed</option>
          </select>
        </div>
        {filteredOrders.length === 0 ? (
          <div>No orders assigned to you.</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>User ID</th>
                  <th>Order ID</th>
                  <th>Order Type</th>
                  <th>Event Name</th>
                  <th>Total Image</th>
                  <th>Date</th>
                  <th>Order Status</th>
                  <th>Editor</th>
                  <th>Message</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredOrders.map((val, index) => {
                  const {
                    id,
                    userId,
                    serviceId,
                    order_name,
                    quantity,
                    createdAt,
                    status,
                    editor,
                    message,
                  } = val;
                  const { text, className } = getStatusDetails(status);
                  return (
                    <tr key={index}>
                      <th>{index + 1}</th>
                      <td>{userId?.id || "N/A"}</td>
                      <td>{id}</td>
                      <td>{serviceId?.service || "N/A"}</td>
                      <td>{order_name}</td>
                      <td>{quantity}</td>
                      <td>
                        {createdAt
                          ? new Date(createdAt).toLocaleDateString()
                          : "N/A"}
                      </td>
                      <td>
                        <button
                          className={`btn text-center p-2 rounded ${className}`}
                        >
                          {text}
                        </button>
                      </td>

                      <td>{editor}</td>
                      <td>{message || "-"}</td>
                      <td>
                        <Link
                          to={`/culling-editor-detail/${id}`}
                          className="d-flex align-items-center gap-2"
                        >
                          <FaRegEdit className="fs-5" />
                        </Link>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </EditorLayout>
  );
};

export default CullingEditor;
